import { Routes } from '@angular/router';
import { rootSystemAdminGuard } from '../../../lib/guards/admin-role.guard';

export const chapterRoutes: Routes = [
  {
    path: 'master/chapter',
    canActivate: [rootSystemAdminGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/chapter-list-page/chapter-list-page.component'
          ).then((m) => m.ChapterListPageComponent),
      },
    ],
  },
];
